<template>
	<div class="pb-3 bg-white rounded-cus cus-box-shadow shop-cart">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pt-3 pl-2 pr-2 d-flex">
				<div class="col-8 pl-0 mt-auto mb-auto font-size-12 font-size-sm-11">Keranjang Belanja</div>
				<div class="col-4 rounded-pill bg-blue font-size-10 color-white m-auto pt-1 pb-1 text-center">{{total_cart}} Item</div>
			</div>
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-bottom"></div>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 font-size-11 color-gray-2 shop-cart-item" id="shop-cart-container">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center" v-if="cart.length < 1">
				<div class="col-6 col-md-12 pl-0 pr-0 pt-4 text-center">
					<img class="img-fluid" src="/assets/transaction/keranjang-belanja-kosong.png">
				</div>
				<div class="col-12 pl-0 pr-0 text-center pt-2 font-size-sm-10">Keranjang Belanja Anda masih kosong...</div>
			</div>
			<div class="col-12 pl-0 pr-0 text-center shop-cart-item" v-if="cart.length > 0">
				<div class="col-12 pl-2 pr-2 pt-3 d-flex" v-for="(value, index) in cartShow" :key="index">
					<div class="col-2 pl-0 mt-auto mb-auto"><img class="img-fluid" :src="value.product_image"></div>
					<div class="col-9 pl-0 text-left">
						<div class="col-12 font-size-11 color-black">{{value.product_name}}</div>
						<div class="col-12 font-size-9 color-gray-2">{{value.price | toRupiah}}</div>
						<div v-if="step == 1" class="col-12 pt-1 d-flex justify-content-start">
							<button @click="minQty(index)" class="btn p-0 color-blue no-box-focus btn-hover ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-minus-circle"></i></span>
							</button>
							<input @keypress="onlyNumber" @paste.prevent v-model="value.quantity" @change="cekQty(index)" type="text" class="col-4 form-control form-control-sm font-size-9 font-weight-bold no-box-focus text-center">
							<button @click="addQty(index)" class="btn p-0 color-blue ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-plus-circle"></i></span>
							</button>
						</div>
					</div>
					<div class="col-1 text-right mt-auto mb-auto">
						<span @click="deleteCart(value.product_id)" v-show="step == 1" class="cursor-pointer color-red"><i class="fas fa-trash"></i></span>
						<span v-show="step > 1" class="">{{value.quantity}}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-3 font-size-11">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex color-gray-2">
				<div class="col-6 pl-0">Subtotal</div>
				<div class="col-6 pr-0 text-right">{{price_total | toRupiah}}</div>
			</div>
			<!-- <div class="col-12 pl-2 pr-2 pt-2 d-flex color-gray-2" v-if="(!mitra || register) && Object.values(registerItem).length > 0">
				<div class="col-7 pl-0" v-html="registerItem.title.replace(/[(]/g, '<br>(')"></div>
				<div class="col-5 pr-0 text-right">{{ registerItem.price | toRupiah}}</div>
			</div> -->
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-bottom"></div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 pb-5 pb-lg-0 mt-3 font-size-12">
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0">Total</div>
				<div class="col-6 pr-0 text-right">{{price_total | toRupiah}}</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-2 font-size-11 color-mila">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0">Total BV</div>
				<div class="col-6 pr-0 text-right">{{bv_total | toNumber}}</div>
			</div>
		</div>
		<!-- <div class="col-12 pl-0 pr-0 btn-cart" v-if="step == 1">
			<button :disabled="cart.length == 0" class="col-12 btn bg-blue color-white no-box-focus" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div> -->
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step > 0 && step < 2">
			<button class="col-4 btn bg-red color-white no-box-focus" @click="step_down" v-if="step > 0">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button :disabled="step == 1 && cart.length == 0" class="col-8 btn bg-blue color-white no-box-focus" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="(step == 2)">
			<button class="col-4 btn bg-red color-white no-box-focus" @click="step_down">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button :disabled="paymentProgress == false" class="col-8 btn bg-blue color-white no-box-focus" @click="bayar">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Simpan</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>
		<!-- <div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step == 4">
			<a :href="responsePaymentPdf" target="_blank" class="col-6 btn bg-light-blue color-white no-box-focus">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-print mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Cetak Invoice</div>
				</div>
			</a>
			<button class="col-6 btn bg-blue color-white no-box-focus" @click="resetSemua">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Transaksi Kembali</div>
				</div>
			</button>
		</div> -->
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions} from 'vuex';
import validator from 'validator';
export default {
	components: {
	},
	data() {
		return {
			kosong: false,
		}
	},
	props: {
		registrationData: {
			type: Object
		},
		alert: {
			type: Object
		}
	},
	computed: {
		...mapState('po_cart', ['step', 'cart', 'dataSerial', 'mitra', 'register',  'alertKeranjang', 'selectedPayment', 'selectedPaymentValue', 'payTotal', 'progressBayar', 'registerItem', 'responsePaymentPdf', 'dataProduk', 'serialOptionName', 'paymentProgress', 'warehouseId']),
		...mapState('commonList', ['mitraMLM', 'mandatoryError']),
		...mapState('auth', ['userData']),

		total_cart(){
			if(this.cart){
				return this.cart.length
			}
			return 0;
		},
		price_total(){
			let price_total = 0
			if(this.cart){
				this.cart.forEach(el => {
					price_total += parseInt(el.price) * parseInt(el.quantity)
				});
			}
			return price_total;
		},
		dataProduct() {
			var product = this.cart.map( (el) => {
				//console.log(el)
				//console.log(this.userData)

				let obj = {
					product_code: el.product_code,
					product_id: el.product_id,
					product_name: el.product_name,
					//product_price: el.product_price,
					product_unit: el.product_unit,
					product_bv: el.product_bv,
					quantity: el.quantity,
				}

				if (this.userData.stockist_order_count >= 4 || this.userData.stockist_level == 'mb') {
					obj.product_price = el.product_price_original
				} else {
					obj.product_price = el.product_price
				} 

				return obj
			})
			return product
		},
		cartShow() {
			return this.cart.filter((el) => {
				return el.quantity > 0
			})
		},
		bv_total() {
			let bv_total = 0
			if(this.cart){
				this.cart.forEach(el => {
					bv_total += parseInt(el.product_bv) * parseInt(el.quantity)
				});
			}
			return bv_total
		}
	},
	methods: {
		...mapMutations('po_cart', ['step_up', 'step_down', 'setAlertKeranjang', 'reset']),
		...mapActions('po_cart', ['changeCartQty', 'deleteCart', 'savePO']),
		...mapMutations('commonList', ['setAlertMandatory']),
		...mapActions('commonList', ['checkMandatory', 'getmitraMLM']),

		resetSemua(){
			if (this.register) {
				this.registrationData.mitra_code = ''
				this.registrationData.email = ''
				this.registrationData.name = ''
				this.registrationData.mobilephone = ''
			} else if (!this.mitra) {
				this.registrationData.mitra_code =  ''
				this.registrationData.email =  ''
				this.registrationData.name =  ''
				this.registrationData.card_id =  ''
				this.registrationData.mobilephone =  ''
			}
			this.reset()
		},
		checkRegisterItem() {
			/*cek jumlah produk register di produk apakah cart register + 1 cukup dengan sisa stock*/

			//let registerProduct = this.dataProduk.find(element => element.product_code == this.registerItem.code)
			//let registerInCart = this.cart.find(element => element.product_code == this.registerItem.code)
			//let quantityRegister = registerInCart ? registerInCart.quantity : 0
			//if ((registerProduct.stock_pos - quantityRegister) >= 0) {
				this.step_up()
			//} else {
				//this.setAlertKeranjang(`Silahkan melakukan penambahan produk ${this.registerItem.name}`)
			//}
		},
		lanjut(){
			if (this.step == 1) {
				if (!this.register) {
					if (this.mitra) {
						this.validateCart()
					} else {
						this.validateData().then( () => {
							var filter = Object.values(this.alert).filter((el)=>{
								return el != ""
							})
							if (filter.length == 0) {
								this.step_up()
							}
						})
					}
				} else {
					this.validateCart()
				}
			} else if (this.step == 2) {
				if (this.userData.stockist_trx_method !== 'system') {
					this.setAlertKeranjang(`Silakan beralih menggunakan Metode Transaksi Sistem untuk melanjutkan transaksi`)
				} else {
					if (this.dataSerial.length > 0) {
						this.dataSerial.forEach( (element, index) => {
							if (element.max_qty != element.serial.length) {
								this.setAlertKeranjang(`Jumlah serial ${this.serialOptionName[element.type]} ${element.product_code} harus ${element.max_qty}`)
							}
							if (index == this.dataSerial.length-1 && !this.alertKeranjang) {
								this.step_up()
							}
						});
					} else {
						this.step_up()
					}
				}
			}
		},
		validateCart(){
			this.cart.forEach( (element, index) => {
				// if (parseInt(element.quantity) > parseInt(element.stock_pos)) {
				// 	this.setAlertKeranjang(`Jumlah ${element.product_name} Melebihi Stok`)
				// }
				if (index == this.cart.length-1 && !this.alertKeranjang) {
					this.step_up()
				}
			});
		},
		validateData(){
			return new Promise( async (resolve) => {
				if (!this.registrationData.mitra_code) {
					this.alert.mitra_code = "Data tidak boleh kosong"
				} else {
					this.alert.mitra_code = ""
					this.getmitraMLM({
						member_network_mid: this.registrationData.mitra_code
					}).then( () => {
						if (!this.mitraMLM.status) {
							this.alert.mitra_code = 'Kode Mitra tidak ditemukan'
						}
					})
				}
				if (!this.registrationData.email) {
					this.alert.email = "Data tidak boleh kosong"
				} else if (!validator.isEmail(this.registrationData.email)) {
					this.alert.email = "Email tidak valid"
				} else {
					this.alert.email = ""
				}
				if (!this.registrationData.name) {
					this.alert.name = "Data tidak boleh kosong"
				} else {
					if (this.registrationData.name.length < 3) {
						this.alert.name = "Nama terlalu pendek"
					} else {
						this.alert.name = ""
					}
				}
				if (!this.registrationData.card_id) {
					this.setAlertMandatory({type:'ktp', data: "Data tidak boleh kosong"})
				} else if (!validator.isLength(this.registrationData.card_id , {min:16 , max:16})) {
					this.setAlertMandatory({type:'ktp', data: "KTP tidak valid"})
				} else {
					await this.checkMandatory({type:'ktp', data: this.registrationData.card_id})
				}
				if (!this.registrationData.mobilephone) {
					this.setAlertMandatory({type:'hp', data: "Data tidak boleh kosong"})
				} else if (!validator.isLength(this.registrationData.mobilephone , {min:10 , max:15})) {
					this.setAlertMandatory({type:'hp', data: "Nomor tidak valid"})
				} else {
					await this.checkMandatory({type:'hp', data: this.registrationData.mobilephone})
				}
				resolve()
			})
		},
		cekQty(index){
			this.changeCartQty({
				type: '',
				index: index
			})
		},
		minQty(index){
			this.changeCartQty({
				type: 'min',
				index: index
			})
		},
		addQty(index){
			this.changeCartQty({
				type: 'plus',
				index: index
			})
		},
		bayar(){
			if (!this.selectedPayment.value) {
				this.setAlertKeranjang(`Silahkan Pilih Metode Pembayaran`)
			} else {
				let price_total = this.price_total
				let product = [... this.dataProduct]
				let payment_method = this.selectedPayment.value
				let payment_method_text = this.selectedPayment.text
				let payment_method_value = this.selectedPaymentValue
				let customer_network_mid = this.userData.stockist_network_mid
				let warehouse_id = this.warehouseId

				let params = {
					price_total: price_total,
					product: product,
					payment_method: payment_method,
					payment_method_text: payment_method_text,
					payment_method_value: payment_method_value,
					customer_network_mid: customer_network_mid,
					warehouse_id: warehouse_id,
				}

				//console.log(params)
				this.savePO(params)
			}
		}
	},
	watch: {
		mandatoryError: {
			deep:true,
			handler: function (val) {
				if (!this.mitra) {
					this.alert.card_id = val.ktp
					this.alert.mobilephone = val.hp
				}
			}
		}
	}
};
</script>

<style scoped>
</style>
